import { render, staticRenderFns } from "./press.vue?vue&type=template&id=88aa1382&scoped=true"
import script from "./press.vue?vue&type=script&lang=js"
export * from "./press.vue?vue&type=script&lang=js"
import style0 from "./press.vue?vue&type=style&index=0&id=88aa1382&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88aa1382",
  null
  
)

export default component.exports